var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpSymbolikuvitus96132(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "2021_OP_symbolikuvitus_96_132 1",
    clipPath: "url(#clip0_3248_4854)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "taustavalko"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M96 0H0V96H96V0Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M66.1099 67.1299V74.1999C66.1099 76.1399 68.9599 77.7099 72.4799 77.7099C75.9999 77.7099 78.8499 76.1399 78.8499 74.1999V67.1299",
    stroke: "#6E6E6E",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M72.4799 69.82C75.9979 69.82 78.8499 68.5261 78.8499 66.93C78.8499 65.3339 75.9979 64.04 72.4799 64.04C68.9618 64.04 66.1099 65.3339 66.1099 66.93C66.1099 68.5261 68.9618 69.82 72.4799 69.82Z",
    stroke: "#6E6E6E",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M78.8499 70.9199C78.8499 72.5099 75.9999 73.8099 72.4799 73.8099C68.9599 73.8099 66.1099 72.5099 66.1099 70.9199",
    stroke: "#6E6E6E",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M14.4998 36.5898C13.0613 36.5898 11.6811 37.1585 10.6601 38.1719C9.63921 39.1854 9.06036 40.5614 9.0498 41.9998V46.2098H19.9398",
    stroke: "#6E6E6E",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M49.86 71.3398V57.7198V41.9198C49.8312 40.4962 49.2454 39.1406 48.2283 38.1441C47.2112 37.1476 45.8439 36.5896 44.42 36.5898H14.5C15.9368 36.5924 17.3144 37.1623 18.3332 38.1755C19.352 39.1886 19.9295 40.5631 19.94 41.9998V59.8598V75.6698C19.9663 77.096 20.5527 78.4546 21.5725 79.452C22.5923 80.4493 23.9636 81.0053 25.39 80.9998H55.31",
    stroke: "#6E6E6E",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M55.2999 71.3398H30.8299V75.5499C30.8299 76.9918 30.2585 78.375 29.2407 79.3965C28.223 80.418 26.8419 80.9946 25.3999 80.9998H55.3099C56.7536 80.9972 58.1373 80.4218 59.1572 79.4C60.1771 78.3783 60.7499 76.9935 60.7499 75.5499V71.3398H55.2999Z",
    stroke: "#6E6E6E",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M25.4897 46.24H44.3097",
    stroke: "#6E6E6E",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M25.4897 52.6199H44.3097",
    stroke: "#6E6E6E",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M25.4897 58.99H44.3097",
    stroke: "#6E6E6E",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M25.4897 65.3699H44.3097",
    stroke: "#6E6E6E",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M72.3298 18.9299H65.5298L68.9198 25.3499L72.3298 18.9299Z",
    fill: "white",
    stroke: "#6E6E6E",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M82.62 44C82.62 52.61 76.49 59.6 68.93 59.6C61.37 59.6 55.23 52.6 55.23 44C55.23 32.21 68.93 25.28 68.93 25.28C68.93 25.28 82.62 31.77 82.62 44Z",
    fill: "white",
    stroke: "#6E6E6E",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M68.93 25.71L67.27 28.83",
    stroke: "#6E6E6E",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M68.9297 25.71L70.5797 28.83",
    stroke: "#6E6E6E",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M72.6899 47.8199C72.3175 48.1863 71.8748 48.4736 71.3884 48.6644C70.9021 48.8552 70.3821 48.9455 69.8599 48.9299C67.2199 48.9299 66.1299 47.2799 65.9699 44.7299H65.4099C65.2981 44.7451 65.1848 44.7158 65.0944 44.6482C65.0041 44.5807 64.9439 44.4803 64.9268 44.3688C64.9098 44.2573 64.9372 44.1435 65.0033 44.0521C65.0693 43.9606 65.1687 43.8988 65.2799 43.8799C65.3227 43.87 65.3671 43.87 65.4099 43.8799H65.9399V42.2599H65.4099C65.3547 42.2612 65.2998 42.2517 65.2484 42.2318C65.1969 42.2119 65.1499 42.1821 65.1099 42.144C65.07 42.1059 65.038 42.0603 65.0156 42.0099C64.9933 41.9594 64.9812 41.905 64.9799 41.8499C64.9799 41.7385 65.0241 41.6317 65.1029 41.5529C65.1817 41.4741 65.2885 41.4299 65.3999 41.4299H65.9999C66.1599 38.9599 67.3099 37.1799 69.9999 37.1799C70.5032 37.1549 71.0061 37.2375 71.4751 37.422C71.9441 37.6065 72.3684 37.8887 72.7199 38.2499C72.8184 38.3505 72.8815 38.4803 72.8999 38.6199C72.8923 38.7508 72.8356 38.8741 72.741 38.9649C72.6464 39.0558 72.521 39.1076 72.3899 39.1099C72.1899 39.1099 72.0799 38.9399 71.8399 38.7299C71.3136 38.3257 70.6631 38.1171 69.9999 38.1399C68.1099 38.1399 67.2099 39.3299 67.0699 41.4299H70.4099C70.5186 41.4299 70.6229 41.4731 70.6998 41.55C70.7767 41.6269 70.8199 41.7311 70.8199 41.8399C70.815 41.9471 70.7702 42.0485 70.6944 42.1244C70.6185 42.2002 70.5171 42.245 70.4099 42.2499H66.9999V43.8699H70.3699C70.4814 43.8895 70.5811 43.9514 70.6481 44.0427C70.7152 44.134 70.7445 44.2476 70.7299 44.3599C70.7176 44.451 70.6757 44.5356 70.6106 44.6007C70.5456 44.6657 70.461 44.7076 70.3699 44.7199H66.9999C67.1499 46.8999 67.9999 47.9999 69.8599 47.9999C70.5811 48.0283 71.2892 47.8017 71.8599 47.3599C72.1299 47.1499 72.2399 46.9999 72.4599 46.9999C72.519 46.9986 72.5778 47.0089 72.6329 47.0303C72.688 47.0517 72.7383 47.0837 72.781 47.1246C72.8238 47.1654 72.858 47.2143 72.8818 47.2684C72.9057 47.3225 72.9186 47.3808 72.9199 47.4399C72.891 47.5899 72.8095 47.7247 72.6899 47.8199Z",
    fill: "#6E6E6E"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3248_4854"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 96,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpSymbolikuvitus96132);
export default __webpack_public_path__ + "static/media/OP_symbolikuvitus_96_132.218595cc3000a8a55a1ad3c8b2e94a5b.svg";
export { ForwardRef as ReactComponent };